export enum UserType {
  NEW,
  TEAM
}
